import React from 'react';
import {
  Text,
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import useFlowsResetState from '../../../../hooks/useFlowsResetState';
import { useFlowsDispatch } from '../../../../../../common/src/utils/globalVariables';
import { setLastPosition } from '../../../../store/redux/slices/flowsMetaDataSlice';
import { useFlowsRouteParams } from '../../../../hooks/useFlowsRouteParams';
import flowsConfig, {
  defaultFlowsConfig,
} from '../../../../config/flowsConfig';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ActiveSessionModal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const flowsDispatch = useFlowsDispatch();
  const { reset } = useFlowsResetState();
  const { flowId } = useFlowsRouteParams();

  const flowSrc = (
    flowsConfig[flowId || ''] || defaultFlowsConfig(flowId || '')
  ).src;

  const handleReset = () => {
    reset();
    flowsDispatch(setLastPosition(0));
    history.push(flowSrc);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('Active session')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text textStyle="normalBody">
            {t(
              'There is a session active, do you want to continue the session or start a new one?',
            )}
          </Text>
        </ModalBody>

        <ModalFooter>
          <Flex
            flexDirection={{ base: 'column', mobileL: 'row' }}
            justifyContent="center"
            w="100%"
          >
            <Button
              borderRadius="full"
              maxW={{ base: '100%', mobileL: '24rem' }}
              variant="tertiary"
              onClick={handleReset}
              mb={{ base: '3', mobileL: 0 }}
              width="full"
            >
              {t('New session')}
            </Button>
            <Button
              maxW={{ base: '100%', mobileL: '24rem' }}
              borderRadius="full"
              variant="solid"
              onClick={onClose}
              ml={{ base: 0, mobileL: '3' }}
              width="full"
            >
              {t('Continue')}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ActiveSessionModal;
